import { lazy, Suspense } from 'react'
import ManufacturingLayout from '../layouts/Manufacturing'
import AuthGuard from '../components/guards/AuthGuard'
import { ConfluencePages, UserRole } from '../enums'
import { UserManualProvider } from '../contexts/userManual'
import LoadingState from '../components/LoadingState'

const Home = lazy(() => import('../pages/manufacturing/Home'))
const OrderIndex = lazy(() => import('../pages/manufacturing/OrderIndex'))
const OrderShipped = lazy(() => import('../pages/manufacturing/OrderShowShipped'))
const OrderCreate = lazy(() => import('../pages/manufacturing/OrderCreate'))
const OrderShow = lazy(() => import('../pages/manufacturing/OrderShow'))
const OrderInstall = lazy(() => import('../pages/manufacturing/OrderInstall'))
const OrderEdit = lazy(() => import('../pages/manufacturing/OrderEdit'))
const ProductCreate = lazy(() => import('../pages/manufacturing/ProductCreate'))
const ProductIndex = lazy(() => import('../pages/manufacturing/ProductIndex'))
const ManufacturerInvite = lazy(() => import('../pages/manufacturing/ManufacturerInvite'))
const UploadInstructionsIndex = lazy(() => import('../pages/manufacturing/UploadIndex'))
const Catalog = lazy(() => import('../pages/manufacturing/Catalog'))
const ProductStorage = lazy(() => import('../pages/manufacturing/ProductStorage'))
const ProductInstall = lazy(() => import('../pages/manufacturing/ProductInstall'))
const DeviceGroupInstall = lazy(() => import('../pages/manufacturing/DeviceGroupInstall'))
const ProductTest = lazy(() => import('../pages/manufacturing/ProductTest'))

export default [
  {
    path: '/manufacturing',
    element: (
      <AuthGuard roles={[UserRole.SUPERADMIN, UserRole.MANUFACTURER]}>
        <UserManualProvider pageId={ConfluencePages.MANUFACTURING}>
          <ManufacturingLayout />
        </UserManualProvider>
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <Suspense fallback={<LoadingState align="center" />}>
            <Home />
          </Suspense>
        )
      },
      {
        path: 'orders',
        element: (
          <Suspense fallback={<LoadingState align="center" />}>
            <OrderIndex />
          </Suspense>
        )
      },
      {
        path: 'orders/shipped',
        element: (
          <Suspense fallback={<LoadingState align="center" />}>
            <OrderShipped />
          </Suspense>
        )
      },
      {
        path: 'orders/create',
        element: (
          <Suspense fallback={<LoadingState align="center" />}>
            <OrderCreate />
          </Suspense>
        )
      },
      {
        path: 'orders/:id',
        element: (
          <Suspense fallback={<LoadingState align="center" />}>
            <OrderShow />
          </Suspense>
        )
      },
      {
        path: 'orders/:id/install',
        element: (
          <Suspense fallback={<LoadingState align="center" />}>
            <OrderInstall />
          </Suspense>
        )
      },
      {
        path: 'orders/:id/edit',
        element: (
          <Suspense fallback={<LoadingState align="center" />}>
            <OrderEdit />
          </Suspense>
        )
      },

      // TODO: OrderShowProductIndex
      {
        path: 'products',
        element: (
          <Suspense fallback={<LoadingState align="center" />}>
            <ProductIndex />
          </Suspense>
        )
      },
      // TODO: orders/:id/products/create
      {
        path: 'products/:id/create',
        element: (
          <Suspense fallback={<LoadingState align="center" />}>
            <ProductCreate />
          </Suspense>
        )
      },
      {
        path: 'products/:id/install',
        element: (
          <Suspense fallback={<LoadingState align="center" />}>
            <ProductInstall />
          </Suspense>
        )
      },
      {
        path: 'products/:id/test',
        element: (
          <Suspense fallback={<LoadingState align="center" />}>
            <ProductTest />
          </Suspense>
        )
      },
      {
        path: 'device-groups/:id/install',
        element: (
          <Suspense fallback={<LoadingState align="center" />}>
            <DeviceGroupInstall />
          </Suspense>
        )
      },
      {
        path: 'upload',
        element: (
          <Suspense fallback={<LoadingState align="center" />}>
            <UploadInstructionsIndex />
          </Suspense>
        )
      },
      {
        path: 'catalog',
        element: (
          <Suspense fallback={<LoadingState align="center" />}>
            <Catalog />
          </Suspense>
        )
      },
      {
        path: 'storage',
        element: (
          <Suspense fallback={<LoadingState align="center" />}>
            <ProductStorage />
          </Suspense>
        )
      }
    ]
  },
  {
    path: '/manufacturing',
    element: (
      <AuthGuard roles={[UserRole.SUPERADMIN]}>
        <UserManualProvider pageId={ConfluencePages.MANUFACTURING}>
          <ManufacturingLayout />
        </UserManualProvider>
      </AuthGuard>
    ),
    children: [
      {
        path: 'invite',
        element: (
          <Suspense fallback={<LoadingState align="center" />}>
            <ManufacturerInvite />
          </Suspense>
        )
      }
    ]
  }
]
